import { palette } from './palette';
import background from 'assets/images/testimonial-bg.webp'
import headerBg from 'assets/images/header-bg.webp'

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      '& .hero-shaped__left-side': {
        flex: '0 0 50%',
        maxWidth: '50%',
  
        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },
  
        '& .hero-shaped__image': {
          width: '50vw',
          
          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          }
        },
      },
    }
  },

  '.dental-container': {
    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      backgroundColor: palette.text.highlight,

      '& .home-hero-pretitle': {
        paddingBottom: 32
      },

      '& .hero-background': {
        objectFit: 'cover',
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '600px',
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
        },
      },
      '& .home-hero-title': {
        maxWidth: 550,
        fontWeight: 'bold',
      },
      '& .home-hero-subtitle': {
        maxWidth: 460,
      },
      '& .login-button': {
        background: palette.text.highlight,
        color: palette.secondary.main,
        borderColor: palette.secondary.main
      }
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '& .benefits-wrapper': {
        padding: '0 10px',
        '& .section-header': {
          paddingBottom: 30
        },
        '& .definition-service-description': {
          paddingBottom: 40,
          color: palette.text.light
        },

        '& .image': {
          borderRadius: 32,
        },

        '& .definition-service-tile': {
          padding: '0px 14px'
        },
        '@media(min-width: 900px)': {
          '& .section-header': {
            paddingBottom: 50
          },
        }
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: palette.background.main,
      },
      '& #pricing-benefit-section': {
        '& .section-header__title, .section-header__subtitle, .subscription-tabs-label, .summary-text, .summary-subtext': {
          color: palette.text.highlight
        },
        '& .planCard': {
          '& .customBenefitsContainer': {
            minHeight: '225px !important'
          },
          '& .price-value': {
            fontSize: 32,
            fontWeight: 'bold',
            color: palette.background.header
          },
          '&:hover': {
            background: palette.text.highlight,
            color: palette.text.primary,
            '& .highlight-divider': {
              background: palette.divider,
            },
          }
        },
        '@media(min-width: 900px)': {
          marginTop: 10,
        },

        '& .subscription-section': {
          '@media(min-width: 900px)': {
            marginTop: 10,
          },

          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
        },
        '& .savings-summary-link': {
          color: palette.text.highlight,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .section-header__subtitle': {
        color: palette.text.level2
      },
      '& .how-cover-image': {
        height: 450,
      },
      '& .step-counter': {
        backgroundColor: palette.background.secondary,
        fontSize: 16,
      },
      '& .step-content': {
        maxWidth: 400,
        color: palette.text.level2
      },
      '@media(max-width: 900px)': {
        '& .how-cover-image': {
          height: '100%',
        },
      }
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`
        },
        '& .savings-header': {
          color: palette.text.primary
        }
      },
      '& .footer-bar': {
        background: palette.background.header
      },
      '& .savings-contact-card': {
        background: palette.background.footer
      }
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, .find-provider-section, & .plan-selection-section, & .checkout-hero-section': {
      background: palette.background.header,
      backgroundImage: `url(${headerBg})`,
      backgroundSize: 'cover',
      '& .hero-header-title, .hero-header-subtitle': {
        color: palette.text.highlight
      }
    },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,
      
      '& .MuiTypography-root': {
        color: palette.text.primary,
      }
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.background.secondary,
      },
      '& .hero-static-title, .hero-static-subtitle': {
        color: palette.text.highlight
      }
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      backgroundColor: palette.background.level1,
      '& .react-multiple-carousel__arrow--left': {
        left: '25%',

        '@media(max-width: 899px)': {
          left: 0,
        },
      },
      '& .react-multiple-carousel__arrow--right': {
        right: '25%',

        '@media(max-width: 899px)': {
          right: 0,
        },
      },
    },
    /* FAQ */
    '& .faq-hero-section': {
      backgroundImage: `url(${headerBg})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',

      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        textAlign: 'left',
        color: palette.text.highlight
      },
      '& .header-container': {
        justifyContent: 'center',
        margin: '0',
      },
      '& .section-header__title-wrapper, .section-header__subtitle-wrapper': {
        display: 'flex',
        justifyContent: 'center'
      },
      '& .hero-link-button': {
        '&:hover': {
          backgroundColor: palette.primary.main
        }
      }
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: 'rgba(71, 86, 112, 0.8)'
      },
      '& .faq-link': {
        fontWeight: 'normal'
      }
    },
    '& .faq-contact-wrapper': {
      background: palette.background.secondary,
      '& .faq-contact-section': {
        '& .contact-img-wrapper': {
          width: '64px',
          maxWidth: '64px',
        },
        '& .contact-card-title, .contact-card-subtitle, .provider-contact-link, .provider-contact-details': {
          color: palette.text.highlight
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '& .customBenefitsContainer': {
          minHeight: '225px !important'
        },
        '&:hover': {
          background: palette.text.highlight,
          color: palette.text.primary,
          '& .highlight-divider': {
            background: palette.divider,
          },
        }
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
      '& .primary-static-button': {
        background: palette.text.highlight,
        color: palette.secondary.main,
        border: `1px solid ${palette.secondary.main}`,
        '&:hover': {
          background: palette.text.highlight,
          color: palette.secondary.main,
          border: `1px solid ${palette.secondary.main}`,
        }
      }
    },

    '& .primary-static-button': {
      background: palette.text.highlight,
      color: palette.secondary.main,
      border: `1px solid ${palette.secondary.main}`,
      '&:hover': {
        background: palette.text.highlight,
        color: palette.secondary.main,
        border: `1px solid ${palette.secondary.main}`,
      }
    },
 
    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      }
    },

    /* Employee */
    '& .employerRootContainer': {
      background: palette.background.description,
      '& .home-hero-wrapper': {

        '@media(max-width: 900px)': {
          paddingTop: 0,
        },

        '& .hero-background': {
          objectFit: 'cover',
        },
        '& .hero-section': {
          display: 'flex',
          alignItems: 'center',
          maxHeight: '620px',
        },
        '& .home-hero-title': {
          maxWidth: '550px',
        },
        '& .home-hero-subtitle': {
          color: palette.text.primary,
          fontSize: 18,
        },
        '& .hero-link-button': {
          background: palette.verticalBar.used,
          color: palette.text.highlight,
        },
        '& .login-button': {
          borderColor: palette.verticalBar.used,
          background: palette.text.highlight,
          color: palette.verticalBar.used,
          '&:hover': {
            background: palette.text.highlight,
          },
        },
        '@media screen and (max-width: 768px)': {
          '& .home-hero-title': {
            fontSize: '34px',
            color: palette.text.primary,
          },
        },
        '& .header-subtitle-divider': {
          marginTop: '0px !important',
          marginBottom: '32px !important',
        },
        '& .image': {
          display: 'block',
        },
        '@media(min-width: 1024px) and (max-width: 1366px)': {
          '& .image': {
            objectPosition: 'center',
            display: 'block',
          },
          '& .header-subtitle-divider': {
            marginTop: 12,
            marginBottom: 25,
          },
          '& .hero-title': {
            fontSize: 36,
          },
        },
        '& .customSubtitleItems': {
          fontSize: '18px !important',
        },
      },
      '& .hero-link-button, .login-button': {
        borderRadius: 4,
      },
      '& .hero-subtitle-divider-container': {
        '& .hero-subtitle-divider': {
          border: `2px solid ${palette.text.primary}`,
        },
      },
      '& .accordion__item-wrapper': {
        paddingTop: '10px',
        border: 'none !important',
        borderBottom: `1px solid ${palette.divider} !important`,
        borderRadius: '0 !important',
      },

      /* Subscription */
      '& .subscription-wrapper': {
        background: palette.background.description,
        '& .section-header__subtitle, .customDisclaimerText': {
          color: palette.text.light,
        },
        '& .section': {
          '@media(min-width: 900px)': {
            padding: '64px',
          },
        },
        '& .subscription-getstarted-button': {
          background: palette.verticalBar.used,
          color: palette.text.highlight,
        },
        '& #pricing-benefit-section': { 
          '& .subscription-section': {
            '& .section-header': {
              maxWidth: 900,
            }
          },
          '& .summary-text': {
            fontSize: 18,
          },
        },
        '& .customStaticCard': {
          height: 300,
          border: `1px solid ${palette.primary.main}`,
          borderRadius: '12px;',
        },
        '@media(min-width: 768px) and (max-width: 1180px)': {
          '& .customCardContainer': {
            maxWidth: '48%',
          },
        },
        '& .customValue': {
          color: palette.secondary.main,
        },
        '& .step-counter': {
          background: `${palette.background.tableAlternate} !important`,
        },
        '& .customStartMembership': {
          borderRadius: 4,
          height: 70,
        },
        '& .MuiSwitch-thumb': {
          background: palette.text.highlight,
        },
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
          backgroundColor: palette.verticalBar.used,
        },
        '& .MuiSwitch-track': {
          border: 'none',
          background: palette.verticalBar.used,
        },
        '& .customCardContent': {
          paddingBottom: 0,
        },
      },

      /* How it works */
      '& .howitworks-section': {
        '& .howitworks-wrapper': {
          borderBottom: 'none',
          '& .section-header__title, & .section-header__subtitle': {
            textAlign: 'left',
          }
        },
        '& .step-counter': {
          borderRadius: '50%',
          background: palette.primary.main,
          color: palette.text.highlight,
        },
      },

      /* Metrics */
      '& .customMetricsRoot': {
        background: palette.text.highlight,
        '& #metrics-section': {
          '@media(min-width: 900px)': {
            padding: '48px 64px',
          },
          '& .left-section': {
            justifyContent: 'center',
            '& .title-box': {
              marginBottom: 36,
            },
          },
          '& .right-section': {
            justifyContent: 'center',
            '@media(max-width: 899.9px)': {
              padding: 0,
            },
            '& .title-box': {
              marginBottom: 36,
            },
          },
        },
        '& .section-header__title, .customMetricsDescription': {
          color: palette.text.primary,
        },
        '& .metrics': {
          '& .section-header__title': {
            maxWidth: 600,
          },
          '& .metrics-getstarted-button': {
            background: palette.verticalBar.used,
            color: palette.text.highlight,
            borderRadius: 4,
            height: 56,
          },
        },
        '& .customDivider': {
          display: 'none',
        },
      },

      /* Comparison */
      '& .customComparisonContainer': {
        background: palette.verticalBar.used,
        '& .customMainTitle': {
          maxWidth: 450
        },
        '& .customImage': {
          marginBottom: 0,
        },
      },
      '& .customImage': {
        border: 'none',
      },
      '& .customSubtitle': {
        maxWidth: 400,
      },

      /* FAQ */
      '& .FAQSection': {
        background: palette.background.description,
        padding: '48px 24px',

        '@media(min-width: 900px)': {
          padding: '48px 64px',
        },
        '& .accordion__item-wrapper': {
          background: palette.background.description,
          '& .expandIcon, .collapseIcon': {
            color: palette.verticalBar.used,
          },
        },
        '& .accordion__collapsable-text': {
          color: palette.text.light,
        },
      },

      /* Hero Static Footer */
      '& .hero-static-bg': {
        backgroundColor: `${palette.primary.main} !important`,
      },
      '& .hero-static-section': {
        '& .hero-static-title, .hero-static-subtitle': {
          color: `${palette.text.highlight} !important`,
        },
        '& .primary-static-button': {
          background: `${palette.text.highlight} !important`,
          color: `${palette.text.primary} !important`,
          border: 'none',
          borderRadius: 4,
        },
      },
      '& .customBar': {
        color: palette.text.highlight,
      },
      '& .bar_accordion__item-wrapper': {
        padding: 0,
      },
    },

    /* Footer */
    '& .footer-wrapper, & .footer-wrapper a': {
      color: palette.text.highlight,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },
  },
};